export const defaultGroupFields = (fields) => {
  return fields.reduce((acc, field, index) => {
    const { row, col } = field || {};
    if (row && col) {
      const { position: rowPosition } = row;
      if (!acc[rowPosition]) {
        acc[rowPosition] = {
          ...row,
          cols: [],
        };
      }
      const cols = [...acc[rowPosition].cols, field].sort((a, b) => {
        if (a.col && b.col) {
          return a.col.position - b.col.position;
        }
        return 0;
      });
      acc[rowPosition] = {
        ...acc[rowPosition],
        cols,
      };
      return acc;
    }
    acc[index] = {
      cols: [field],
    };
    return acc;
  }, {});
};
